import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const EvaluationHubPage = lazy(() =>
  import('../pages/evaluation/EvaluationHubPage').then((m) => ({ default: m.EvaluationHubPage }))
)
const CriteriaTemplatesPage = lazy(() =>
  import('../pages/evaluation/CriteriaTemplatesPage').then((m) => ({ default: m.CriteriaTemplatesPage }))
)
const CyclesPage = lazy(() =>
  import('../pages/evaluation/CyclesPage').then((m) => ({ default: m.CyclesPage }))
)
const EvaluationsPage = lazy(() =>
  import('../pages/evaluation/EvaluationsPage').then((m) => ({ default: m.EvaluationsPage }))
)
const EvaluateFormPage = lazy(() =>
  import('../pages/evaluation/EvaluateFormPage').then((m) => ({ default: m.EvaluateFormPage }))
)
const ScorecardsPage = lazy(() =>
  import('../pages/evaluation/ScorecardsPage').then((m) => ({ default: m.ScorecardsPage }))
)
const AnalyticsPage = lazy(() =>
  import('../pages/evaluation/AnalyticsPage').then((m) => ({ default: m.AnalyticsPage }))
)
const ActionPlansPage = lazy(() =>
  import('../pages/evaluation/ActionPlansPage').then((m) => ({ default: m.ActionPlansPage }))
)

// Service Evaluation & 360° — cross-actor evaluation module (evaluation-service).
export const evaluationRoutes: RouteObject[] = [
  {
    path: 'evaluation',
    children: [
      { index: true, element: <EvaluationHubPage /> },
      { path: 'criteria', element: <CriteriaTemplatesPage /> },
      { path: 'templates', element: <CriteriaTemplatesPage /> },
      { path: 'cycles', element: <CyclesPage /> },
      { path: 'evaluations', element: <EvaluationsPage /> },
      { path: 'evaluations/:id', element: <EvaluateFormPage /> },
      { path: 'scorecards', element: <ScorecardsPage /> },
      { path: 'rankings', element: <ScorecardsPage /> },
      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'actions', element: <ActionPlansPage /> },
    ],
  },
]
